const f_s = '.'; // разделитель дробной части

/**
 * В число
 * @param {*} v - значение
 * @return {number}
 */
export const toNumber = v => typeof v === 'string' ? parseFloat(v.toString().replace(' ', '').replace(',', f_s)) : Number(v);

/**
 * Число?
 * @param {*} v - значение
 * @return {boolean}
 */
export const isNumeric = v => {
    if (typeof v === 'number') {
        return true;
    }
    const str = (v || '').toString();
    if (!str) {
        return false;
    }
    const float = toNumber(str);
    return !isNaN(float) && isFinite(float);
};

/**
 * Форматирование цены
 * @param {(number|string)} amount число
 * @param {number} [x=3] длина секции
 * @param {string} [s=' '] разделитель секций
 * @param {number} [d=0] длина дробной части
 * @param {string} [c='.'] разделитель дробной части
 * @return {string}
 */
export const toCurrency = (amount, x = 3, s = ' ', d, c = f_s) => {
    const n = toNumber(amount);
    d = d || (x => (x.includes('.') ? x.split('.').pop().length : 0))(n.toString());
    const str = n.toFixed(Math.max(0, ~~d));
    const re = `\\d(?=(\\d{${x}})+${d > 0 ? '\\D' : '$'})`;
    return (c ? str.replace('.', c) : str).replace(new RegExp(re, 'g'), `$&${s}`);
};

/**
 * Целая часть от деления
 * @param {Number} a
 * @param {Number} b
 * @return {number}
 */
export function integerDivision(a, b) {
    return (a - a % b) / b;
}
